import React from "react";
import {css} from "emotion";
import CardList from "./CardList";
import AddPaymentForm from "./AddPaymentForm";
import InvoiceList from "./InvoiceList";
import {colors, boxStyles} from "../../styles/theme";
import {BillingProvider} from "../../context/BillingState";
import TitleWithBackButton from "../TitleWithBackButton";
import Usage from "./Usage";

const BillingBody = () => {
  return (
    <BillingProvider>
      <div className={container}>
        <div className="desktop">
          <TitleWithBackButton
            title="Billing"
            backLocation="settings"
          />
        </div>
        <Usage/>
        <div className="horizontalLine"/>
        <CardList/>
        <div className="horizontalLine"/>
        <AddPaymentForm/>
        <div className="horizontalLine"/>
        <InvoiceList/>
      </div>
    </BillingProvider>
  );
};

export default BillingBody;

const container = css`
  padding-top: 30px;

  .desktop {
    display: none;
  }
  .horizontalLine {
    height: 2px;
    background-color: ${colors.lineBreak};
    border-radius: 0;
    margin: 10px 0;

    @media screen and (min-width: ${boxStyles.desktopBreak}) {
      border-radius: 5px;
    }
  }
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop {
      display: block;
    }
  }
`;
